<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>Edit Shipping Policy Template</h2>
    </div>
    <div class="template" v-loading="loading">
      <el-form ref="form" :model="formDetail">
        <community-postages ref="CommunityPostages"></community-postages>
        <div class="store_box store_btn_box">
          <div class="store_btn" @click="$router.go(-1)">Cancel</div>
          <div class="store_btn primary" @click="SavePostages">Save</div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import ex from '@/api/enum'
import CommunityPostages from '@/components/community-postages'
export default {
  name: '',
  components: { CommunityPostages },
  data() {
    return {
      loading: false, //page loading
      formDetail: {
        name: "",
        logo: "",
        store: "",
        email: "",
        paypal: "",
        phone: ""
      },
      radio: 3,
      sales: [],
      all_sales: ex.cardhobby.sales,
      // getTabNum: 1,
    }
  },
  mounted() { },
  methods: {
    SavePostages() {
      let that = this;
      that.loading = true;
      this.$refs.CommunityPostages.$refs.CreateCardForm.validate(function (valid) {
        if (valid) {
          // console.log("success validate!!");
          let _postages = that.$refs.CommunityPostages.FormData;
          // console.log('_postages',_postages)
          let _CommunityPostages = [];
          if (_postages['CommunityPostages'].length) {
            _postages['CommunityPostages'].map((obj, k) => {
              let cp = { ...obj }; // 快递模板信息
              if (obj.Price > 0) {
                cp['Price'] = that.$store.getters.priceExchange(obj.Price);
              }
              _CommunityPostages.push(cp);
            });
          }
          setTimeout(() => {
            that.$post('SaveInfoAddress', { 'CommunityPostages': _CommunityPostages })//保存快递模板信息
              .then((res) => {
                // console.log("axios-SaveInfoAddress:", res);
                if (res.result) {
                  that.$message({
                    showClose: true,
                    message: res.msg || 'Success',
                    type: 'success',
                  });
                  that.$refs.CommunityPostages.getData("GetMemberAddress");//community-postages 获取快递模板信息
                  that.$router.push({ name: "store", params : { getTabNum: 1 }})
                }
                that.loading = false;
              })
              .catch((err) => {
                // console.log(err);
                that.loading = false;
              });
          }, 800);
        } else {
          that.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/allstore.css";

.template {
  width: 530px;
}

.store_select {
  width: 100%;
  margin-bottom: 20px;
}

.store_ipt {
  width: 200px;
}

.store_select_box {
  display: flex;
}

.store_radio {
  width: 100%;
  margin-top: 10px;
}

.text_blue {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/shipment.vue